module.exports = __webpack_public_path__ + "fonts/iconfont.828f7bc9.eot";